import { render, staticRenderFns } from "./ContributorList.vue?vue&type=template&id=4029b00e&scoped=true&"
import script from "./ContributorList.vue?vue&type=script&lang=js&"
export * from "./ContributorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029b00e",
  null
  
)

export default component.exports